import { Component, OnInit, inject } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';

import {
  CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto,
  CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { CreatePublicReceiveKeywordCommand } from '.././../../../core/api/models/create-public-receive-keyword-command';
import { GetUsedPublicNumbersWithPaginationDto } from '.././../../../core/api/models/get-used-public-numbers-with-pagination-dto';
import { PaginatedListOfGetUsedPublicNumbersWithPaginationDto } from '.././../../../core/api/models/paginated-list-of-get-used-public-numbers-with-pagination-dto';
import { ReceiveKeywordsService } from '.././../../../core/api/services/receive-keywords.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { SelectSearchModule } from 'src/app/shared/components/select-search/select.search.module';
import { PublicReceiveKeywordsFormComponent } from './public-receive-keywords-form/public-receive-keywords-form.component';


@Component({
    selector: 'app-public-receive-keywords',
    templateUrl: './public-receive-keywords.component.html',
    imports: [
        BaseIndexModule,
        SelectSearchModule,
        PublicReceiveKeywordsFormComponent,
    ]
})
export class PublicReceiveKeywordsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = 'assignNumbers.publicReceiveKeywords';

  /* Refactored properties */
  protected currentService = inject(ReceiveKeywordsService);
  paginationApiMethodName: string = this.currentService.receiveKeywordsGetUsedPublicNumbersWithPagination.name;
  createGetApiMethodName: string = this.currentService.receiveKeywordsCreatePublicReceiveKeywordGet.name;
  deleteApiMethodName: string = this.currentService.receiveKeywordsDelete.name;
  auditApiMethodName: string = this.currentService.receiveKeywordsGetReceiveKeywordsAudit.name;
  /* Refactored properties */

  modelWithPagination$: Observable<PaginatedListOfGetUsedPublicNumbersWithPaginationDto>;
  items$: Observable<Array<GetUsedPublicNumbersWithPaginationDto>>;
  formPageConfig: FormPageConfig<CreatePublicReceiveKeywordCommand> = {};
  SmsCpEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.number,
        name: 'number',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: 'common.smsCp',
        name: 'smsCp',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsCp',
      },
    ];
  }

  setDefaultTableSort() {}

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .receiveKeywordsUpdatePublicReceiveKeywordsGet({ PrivateNumberId: id })
      .pipe(this.basePipeOperators())
      .subscribe(
        (
          res: CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto
        ) => {
          try {
            this.formPageConfig.editData.organizationIds = res?.data?.map(
              (item) => {
                return item.organizationId;
              }
            );
            this.formPageConfig.editData.privateNumberId = id;
            this.formPageConfig.editId = id;
            this.pageConfig.isVisibleForm = true;
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.systemManagement
            );
          }
        }
      );
  }

  //#endregion
}
